import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BaseUrl } from "../../config";
import { Banner } from '../../components';
import { Loader } from '../../components';
import {JobsList} from '../../components';
import {DetailJob} from '../../components';
import { FormOverlay } from '../../components';

const CareersDetailContainer = (props) => {
  const [jobDetail, setJobDetail] = useState([])
  const [isFetching, setisFetching] = useState(true)
  const [slugParams, setSlugParams] = useState('') 
  const [arrayJobs, setArrayJobs] = useState([])
  const [isOverlayOpen, setIsOverlayOpen] = useState(false)

  useEffect(() => {
    
    setSlugParams(props.match.params.job)
    
  },[props.match])

  useEffect(() => {
    
    if(slugParams !== ''){
      fetch(`${BaseUrl}/job?key=invrsion&slug=${slugParams}`, {
        method: 'GET'
      })
      .then(response => {
        return response.json()
        
      }).then((json) =>  {
        setJobDetail(json.data.job_opening);
        
      })
    }
    fetch(`${BaseUrl}/jobs?key=invrsion`, {
      method: 'GET',
      headers : { 
        'Accept': 'application/json'
       }
    })
    .then(response => {
      return response.json()
    }).then((json) =>  {
      setArrayJobs(json.data.careers);
      setisFetching(false)
      document.title = json.data.careers[0].job_title
    })
    
  }, [slugParams]);

  const openOverlay = () => {
    setIsOverlayOpen(!isOverlayOpen)
  }
  const heroImg = require('../../assets/careers-hero.jpg');

  const arrayLoad = [
    heroImg
  ]

  return (
    <React.Fragment>
      {
        jobDetail.length > 0 &&
        <DetailJob details={jobDetail[0]} toggleFn={openOverlay}/>
      }
      
      {
        !isFetching && (arrayJobs.length > 0) &&
        <JobsList jobs={arrayJobs} slug={slugParams}  />
      }
      <FormOverlay 
        title="Intrigued? Become a part of our world!" 
        paragraph="Fill out the form below to continue the application process, and we’ll get back to you as soon as possible with additional steps."
        isOverlayOpen={isOverlayOpen}
        closeFn={openOverlay}
        isCareers={true}
        jobTitle={jobDetail[0]?.job_title}
      />
      <Banner 
        text="Not a match? We are always open to new ideas" 
        route="mailto:invrsion@invrsion.com?subject=Spontaneous Application" 
        copyRoute="Reach out" isDownload={true} isExternal={true}/>
      <Loader isFetching={isFetching}  arrayLoad={arrayLoad} />
    </React.Fragment>
  );
};

export default CareersDetailContainer;
